/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { clear, createStore, get, set } from 'idb-keyval';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';

import config from '../../config';

/**
 * @private
 * @typedef {import('idb-keyval').UseStore} UseStore
 */

const contentSettingsV3Key = 'v3_json';
const storeName = 'content_settings';

class ContentSettingsStore {
  /**
   * @param {UseStore} useStore
   */
  constructor(useStore) {
    this.customStore = useStore;
  }

  /**
   * Smaže všechny záznamy pro daný store.
   * @returns {Promise<void>}
   */
  clear() {
    return clear(this.customStore);
  }

  /**
   * Vytvoří nový UseStore.
   * @returns {UseStore}
   */
  static createUseStore() {
    return createStore(config.name, storeName);
  }

  /**
   * Vytvoří nebo přepíše contentSettings.
   * @param {string} rawJson Ukládané content settings.
   * @returns {Promise<void>}
   */
  put(rawJson) {
    if (!isString(rawJson)) {
      throw new TypeError('contentSettings should be string');
    }
    return set(contentSettingsV3Key, rawJson, this.customStore);
  }

  /**
   * Vrátí contentSettings.
   * @returns {Promise<string | null>} Pokud contentSettings neexistuje, tak se vrací null.
   * Jinak je vráceno contentSettings.
   */
  get() {
    return get(contentSettingsV3Key, this.customStore).then(
      (contentSettings) => {
        if (isNil(contentSettings)) {
          return null;
        }
        return contentSettings;
      }
    );
  }
}

export default ContentSettingsStore;
